module.exports = __webpack_public_path__ + "img/vetting.hod.what_is_leavy.e0aa9d2d.jpg";